import { ListGroup, Badge } from "react-bootstrap";
import { FaHome, FaHeadset, FaFileContract, FaBell, FaMoneyCheck, FaMoneyBill, FaEdit, FaFileMedical, FaUserInjured, FaUserMd, FaBox, FaBriefcaseMedical, FaStethoscope, FaCreditCard, FaChartBar, FaFileSignature, FaRobot, FaMapMarkedAlt } from "react-icons/fa";
import { FaRegHandshake } from "react-icons/fa";
import { TbTicket } from "react-icons/tb";
import { hasPerm, getCurrentUser } from "../../common/utils";
import PropTypes from 'prop-types';

const MenuGestor = ({
  pathname,
  perfil_gestor_industria,
  ocultar_receptivos,
  ocultar_atendimentos,
  ocultar_prestadores,
  gestao_aplicacoes,
  habilitar_tela_cod_veeva,
  faturamentosPendentes,
  ambiente_programa_id,
  showSuporteMenu,
  noDashboard,
  tipo_gestor,
  ambiente_linha_cuidado,
  habilitar_indicacao_profissional,
}) => {

  const dados_usuario = getCurrentUser();
  const podeVisualizarFluxoCeaf = hasPerm("view_ceaf_estado") || hasPerm("view_chamados") || dados_usuario?.tipo_usuario === "operador";
  const podeVisualizarHistoricoCeaf = hasPerm("view_ceaf_auditoria_chatbot");

  return (
    <>
    {/* Quem tem dashboard precisa de um caminho de volta para ele, seja gestor interno ou
        de industria - sem isto o gestor de industria entrava no dashboard e nao tinha como
        retornar depois de abrir qualquer outra tela. */}
    {noDashboard === false && (
        <ListGroup variant="flush">
            <ListGroup.Item action href="/home" className="itemMenu" active={pathname.indexOf("/home") !== -1 || pathname === "/"} >
                <FaHome /> Home
            </ListGroup.Item>
        </ListGroup>
    )}

    <div className="list-divider">
        <p>Atendimento ao Paciente</p>
    </div>
    {/*
      * O gestor de indústria não enxerga atendimentos nos programas comuns — só
      * painéis. Na Linha de Cuidado (GMUD-2026-0029 item 15) ele tem leitura
      * anonimizada de diagnóstico, produtos em uso, equipe e compliance, e esses
      * módulos são abas do atendimento: sem esta entrada o perfil fica sem acesso
      * a nada. O recorte por `ambiente_linha_cuidado` mantém o comportamento
      * antigo nos demais programas.
      */}
    {hasPerm("view_atendimentos") && (tipo_gestor === 'interno' || (tipo_gestor === 'industria' && ambiente_linha_cuidado)) && (
        <>
            {!ocultar_atendimentos && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/atendimentos" className="itemMenu" active={pathname === "/atendimentos" || pathname === "/atendimentos/"} >
                    <FaHeadset /> Atendimentos
                    </ListGroup.Item>
                </ListGroup>
            )}
        </>
    )}
    
    {hasPerm("view_autorizacoes") && tipo_gestor === 'interno' && (
        <ListGroup variant="flush">
            <ListGroup.Item action href="/autorizacoes" className="itemMenu" active={pathname.indexOf("/autorizacoes") !== -1} >
                <FaFileContract /> Autorizações
            </ListGroup.Item>
        </ListGroup>
    )}

    {hasPerm("view_ultracarePspAtendimentosCompleto") && habilitar_tela_cod_veeva && (
        <ListGroup variant="flush">
            <ListGroup.Item action href="/codveeva" className="itemMenu" active={pathname.indexOf("/codveeva") !== -1} >
                <FaEdit /> Cód Veeva
            </ListGroup.Item>
        </ListGroup>
    )}

    {hasPerm("view_viewatendimentoscompliance") && gestao_aplicacoes && tipo_gestor === 'interno' && (
        <ListGroup variant="flush">
            <ListGroup.Item action href="/compliance" className="itemMenu" active={pathname.indexOf("/compliance") !== -1} >
                <FaFileContract /> Compliance de Terapia
            </ListGroup.Item>
        </ListGroup>
    )}

    {/* gestor interno acompanha as indicações; o da indústria fica de fora, como nas demais
        telas de operação. Só em programa que oferece a funcionalidade. */}
    {hasPerm("view_prestadores") && tipo_gestor === 'interno' && habilitar_indicacao_profissional && (
        <ListGroup variant="flush">
            <ListGroup.Item action href="/indicacoes-recebidas" className="itemMenu" active={pathname.indexOf("/indicacoes-recebidas") !== -1} >
                <FaRegHandshake /> Indicações Recebidas
            </ListGroup.Item>
        </ListGroup>
    )}

    {hasPerm("view_exames") && tipo_gestor === 'interno' && (
        <ListGroup variant="flush">
            <ListGroup.Item action href="/exames" className="itemMenu" active={pathname.indexOf("/exames") !== -1} >
                <FaFileMedical /> Exames
            </ListGroup.Item>
        </ListGroup>
    )}

    {hasPerm("view_atendimentos") && tipo_gestor === 'interno' && (
        <ListGroup variant="flush">
            <ListGroup.Item action href="/farmacovigilancia" className="itemMenu" active={pathname.indexOf("/farmacovigilancia") !== -1} >
                <FaFileMedical /> Farmacovigilancia
            </ListGroup.Item>
        </ListGroup>
    )}

    {hasPerm("view_atendimentos") && tipo_gestor === 'interno' && (
        <>
                {tipo_gestor === 'interno' && !ocultar_receptivos && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/atendimentos-receptivo" className="itemMenu" active={pathname === "/atendimentos-receptivo" || pathname === "/atendimentos-receptivo/"} >
                    <FaHeadset /> Receptivos
                    </ListGroup.Item>
                </ListGroup>
            )}
        </>
    )}

    {hasPerm("pode_gerar_relatorio") && (
        <ListGroup variant="flush">
            <ListGroup.Item action href="/relatorios" className="itemMenu" active={pathname.indexOf("/relatorios") !== -1} >
            <FaChartBar /> Relatórios
            </ListGroup.Item>
        </ListGroup>
    )}

    {/*hasPerm('view_atendimentos') && (
        <ListGroup variant="flush">   
            <ListGroup.Item action href="/extrato" className="itemMenu" active={this.location.pathname.indexOf('/extrato') !== -1}>
                <FaMoneyCheck /> Extrato
            </ListGroup.Item>    
        </ListGroup>
    )*/}

    {hasPerm("view_atendimentos") && hasPerm("view_faturamentos") && tipo_gestor === 'interno' && (
        <>
            <div className="list-divider">
              <p>Gestão Financeira</p>
            </div>
            {hasPerm("view_atendimentos") && tipo_gestor === 'interno' && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/creditosantecipacao" className="itemMenu" active={pathname.indexOf("/creditosantecipacao") !== -1} >
                        <FaMoneyBill /> Crédito Antecipação
                    </ListGroup.Item>
                </ListGroup>
            )}
            
            {hasPerm("view_atendimentos") && tipo_gestor === 'interno' && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/extratoservicos" className="itemMenu" active={pathname.indexOf("/extratoservicos") !== -1} >
                        <FaMoneyCheck /> Extrato Servicos
                    </ListGroup.Item>
                </ListGroup>
            )}

            {hasPerm("view_faturamentos") && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/faturamentos" className="itemMenu" active={pathname.indexOf("/faturamentos") !== -1} >
                        <FaMoneyCheck /> Faturamentos
                        {faturamentosPendentes > 0 && (
                        <Badge pill bg="danger" className="ms-2">
                            {faturamentosPendentes}
                        </Badge>
                        )}
                    </ListGroup.Item>
                </ListGroup>
            )}
        </>
    )}

    {/* Gerenciamento do Programa */}
    {tipo_gestor === 'interno' && (hasPerm("view_clientes") || hasPerm("view_programas") || hasPerm("view_gestores") || hasPerm("view_operadores") || hasPerm("view_prestadores") || hasPerm("view_planos") || hasPerm("view_carteiras")) && (
        <>
            <div className="list-divider">
                <p>Gerenciamento de Programas e Pacientes</p>
            </div>

            <ListGroup variant="flush">
                {hasPerm("view_programas") && (
                    <ListGroup.Item action href={`/programas/edit/${dados_usuario?.ambiente_programa_id}`} className="itemMenu" active={pathname.indexOf("/programas") !== -1} >
                        <FaBox /> Configurações do Programa
                    </ListGroup.Item>
                )}

                {hasPerm("view_prestadores") && !ocultar_prestadores && (
                    <ListGroup.Item action href="/medicos" className="itemMenu" active={pathname.indexOf("/medicos") !== -1} >
                        <FaUserMd /> Médicos
                    </ListGroup.Item>
                )}

                {/*hasPerm("view_operadores") && dados_usuario.is_superuser && (
                    <ListGroup.Item action href="/operadores" className="itemMenu" active={pathname.indexOf("/operadores") !== -1} >
                        <FaUserMd /> Navegadores
                    </ListGroup.Item>
                )*/}

                {hasPerm("view_beneficiarios") && (
                    <ListGroup.Item action href="/pacientes" className="itemMenu" active={pathname.indexOf("/pacientes") !== -1} >
                        <FaUserInjured /> Pacientes
                    </ListGroup.Item>
                )}

                {hasPerm("view_prestadores") && (
                    <ListGroup.Item action href="/prestadores" className="itemMenu" active={pathname.indexOf("/prestadores") !== -1} >
                        <FaUserMd /> Provedores
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
    )}

    {/* Gerenciamento de Itens */}
    {tipo_gestor === 'interno' && (hasPerm("view_produtos") || hasPerm("view_termos") || hasPerm("view_servicos_procedimentos") || hasPerm("view_doencas") || hasPerm("view_modelos_mensagem") || hasPerm("view_emails") || hasPerm("view_formas_pagamento") || hasPerm("view_campos_personalizados") || hasPerm("view_campos_personalizados_atendimentos") || hasPerm("view_especialidades_medicas") || hasPerm("view_especialidade_multiprofissional") || hasPerm("view_categorias_multiprofissional") || hasPerm("view_farmacias")) && (
        <>
            <div className="list-divider">
            <p>Configurações e Parametrizações</p>
            </div>
            <ListGroup variant="flush">
                {hasPerm("view_formas_pagamento") && (
                    <ListGroup.Item action href="/formaspagamento" className="itemMenu" active={pathname.indexOf("/formaspagamento") !== -1} >
                        <FaCreditCard /> Formas De Pagamento
                    </ListGroup.Item>
                )}

                {hasPerm("view_produtos") && (
                    <ListGroup.Item action href="/produtos" className="itemMenu" active={pathname.indexOf("/produtos") !== -1} >
                        <FaBriefcaseMedical /> Produtos
                    </ListGroup.Item>
                )}

                {hasPerm("view_servicos_procedimentos") && (
                    <ListGroup.Item action href="/servicos" className="itemMenu" active={pathname.indexOf("/servicos") !== -1} >
                        <FaStethoscope /> Serviços/Procedimentos
                    </ListGroup.Item>
                )}

                {hasPerm("view_termos") && (
                    <ListGroup.Item action href="/termos" className="itemMenu" active={pathname.indexOf("/termos") !== -1} >
                        <FaEdit /> Termos
                    </ListGroup.Item>
                )}

                {/* {hasPerm("view_termoplataforma") && ( 
                    <ListGroup.Item 
                        action 
                        href="/termos-plataforma" 
                        className="itemMenu" 
                        active={pathname.indexOf("/termos-plataforma") !== -1}
                    >
                        <FaFileSignature /> Termos da Plataforma
                    </ListGroup.Item>
                )} */}
            </ListGroup>
        </>
    )}

    {tipo_gestor === "interno" && (podeVisualizarFluxoCeaf || podeVisualizarHistoricoCeaf) && (
        <>
        <div className="list-divider">
            <p>CEAF</p>
        </div>
        <ListGroup variant="flush">
            {podeVisualizarFluxoCeaf && (
                <ListGroup.Item action href="/fluxo-ceaf" className="itemMenu" active={pathname.indexOf("/fluxo-ceaf") !== -1}>
                    <FaMapMarkedAlt /> Fluxo CEAF
                </ListGroup.Item>
            )}
            {podeVisualizarHistoricoCeaf && (
                <ListGroup.Item action href="/historico-chatbot" className="itemMenu" active={pathname.indexOf("/historico-chatbot") !== -1}>
                    <FaRobot /> Histórico Chatbot
                </ListGroup.Item>
            )}
        </ListGroup>
        </>
    )}

    {tipo_gestor === 'interno' && hasPerm("view_chamados") && showSuporteMenu && (
        <>
          <div className="list-divider">
            <p>Suporte</p>
          </div>
          <ListGroup variant="flush">
            <ListGroup.Item action href="/chamados" className="itemMenu" active={pathname.indexOf("/chamados") !== -1} >
              <TbTicket /> Chamados
            </ListGroup.Item>
            
            {/* NOVO ITEM NOTIFICAÇÕES */}
            <ListGroup.Item action href="/notificacoes" className="itemMenu" active={pathname.indexOf("/notificacoes") !== -1} >
              <FaBell /> Notificações
            </ListGroup.Item>
          </ListGroup>
        </>
      )}
    
    </>
  );
};

MenuGestor.propTypes = {
  pathname: PropTypes.string.isRequired,
  search: PropTypes.string,
  perfil_gestor_industria: PropTypes.bool,
  ocultar_receptivos: PropTypes.bool,
  ocultar_atendimentos: PropTypes.bool,
  ocultar_prestadores: PropTypes.bool,
  gestao_aplicacoes: PropTypes.bool,
  habilitar_tela_cod_veeva: PropTypes.bool,
  habilitar_indicacao_profissional: PropTypes.bool,
  faturamentosPendentes: PropTypes.number,
  ambiente_programa_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  noDashboard: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([null])]),
  tipo_gestor: PropTypes.string,
  ambiente_linha_cuidado: PropTypes.bool,
};

export default MenuGestor;
